import Component from "./Timezone";
export default Component;
